import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { message } from 'antd'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import Forms from './forms'

export default function Home() {
  const { oid } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [school, setSchool] = useState({})
  const [groups, setGroups] = useState([])
  const [activeGroup, setActiveGroup] = useState('')
  const [teachers, setTeachers] = useState([])
  const [isFormsVisible, setIsFormsVisible] = useState(false)
  const [propsData, setPropsData] = useState({})

  const getKefuList = (groupOid) => {
    axios
      .post('/c/kf_c/kefu/list/get', {
        group_oid: groupOid
      })
      .then(function (response) {
        if (response.errcode === 0) {
          setTeachers(response.data)
        } else {
          message.warning(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const userId = searchParams.get('userId')
    const isBind = searchParams.get('isBind')
    localStorage.setItem('userId', userId)
    localStorage.setItem('isBind', isBind)

    axios.post('/c/kf_c/school/info/get', {
        merchant_oid: oid,
      })
      .then(function (response) {
        if (response.errcode === 0) {
          setSchool(response.data)
        } else {
          message.warning(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })

    if (userId) {
      axios.post('/c/kf_c/consultant/get', {
          user_oid: userId,
        })
        .then(function (response) {
          if (response.errcode === 0) {
            if (!response.data.realname) {
              setPropsData({ userId: userId })
              setIsFormsVisible(true)
            }
          } else {
            message.warning(response.msg)
          }
        })
        .catch(function (error) {
          console.error('请求失败，错误信息为：', error)
        })
    }

    axios.post('/c/kf_c/group/list/get', {
        merchant_oid: oid,
      })
      .then(function (response) {
        if (response.errcode === 0) {
          setGroups(response.data)
          if (response.data.length > 0) {
            setActiveGroup(response.data[0].oid)
            getKefuList(response.data[0].oid)
          }
        } else {
          message.warning(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [oid, location.search])

  const handleGroupClick = (groupOid) => {
    setActiveGroup(groupOid)
    getKefuList(groupOid)
  }

  const handleTeacherClick = (teacher) => {
    navigate(`/chat/${teacher.oid}`)
  }

  const handleQuickConsult = () => {
    if (teachers.length > 0) {
      const randomTeacher = teachers[Math.floor(Math.random() * teachers.length)]
      navigate(`/chat/${randomTeacher.oid}`)
    } else {
      message.warning('当前没有可咨询的老师')
    }
  }

  return (
    <div className="home-page">
      <div className="home-container">
        <div className='home-school'>
          <div className="home-logo"><img src={school.logo} alt="" /></div>
          <div className="home-name">{school.name}报考咨询</div>
        </div>

        <div className='home-main'>
          <div className="home-groups">
            {groups.map((group) => (
              <div
                key={group.oid}
                className={`home-group ${activeGroup === group.oid ? 'home-group-active' : ''}`}
                onClick={() => handleGroupClick(group.oid)}
              >
                {group.name}
              </div>
            ))}
          </div>

          <div className="home-teachers">
            {teachers.map((teacher) => (
              <div key={teacher.oid} className="home-teacher" onClick={() => handleTeacherClick(teacher)}>
                <div className="home-teacher-left">
                  <img src={teacher.avatar || '/images/avatar.png'} alt={teacher.name} />
                  <div className='home-teacher-title'>
                    <div className='home-teacher-top'>{teacher.nickname}</div>
                    <div className='home-teacher-down'>
                      <div className='home-teacher-status'>空闲</div>
                      <div className='home-teacher-status'>{teacher.group_name}</div>
                    </div>
                  </div>
                </div>
                <div className="home-teacher-right">
                  <img src="/images/zixun.png" alt="咨询" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="quick-consult-button" onClick={handleQuickConsult}>快速咨询</div>

      {isFormsVisible && <Forms
        data={propsData}
        isOpen={isFormsVisible}
        isCancel={() => { setIsFormsVisible(false) }}
      />}
    </div>
  )
}
